import React from 'react';

import './floatingMenu.css';

export const FloatingMenu = ({ onShow, icon, buttonText, small, className, children }) => {
	const [open, setOpen] = React.useState(false);

	const outer = React.useRef(null);

	const toggle = () => {
		open ? doClose() : doOpen();
	};

	const doOpen = () => {
		setOpen(true);
		onShow && onShow();
	};

	const doClose = () => {
		setOpen(false);
	};

	const handleClick = e => {
		if (!outer.current.contains(e.target) && e.target.id !== 'modal-body') {
			doClose();
		}
	};

	React.useEffect(() => {
		document.addEventListener('mousedown', handleClick, false);

		return () => {
			document.removeEventListener('mousedown', handleClick, false);
		};
	}, []);

	return (
		<div className="floating-menu" ref={outer}>
			{buttonText ? (
				<button className={`btn ${className || 'btn-primary'} ${small ? 'btn-sm' : ''}`} onClick={toggle}>
					{icon && <i className={`mr10 fa fa-${icon}`} />}
					{buttonText}
					<i className="fa fa-caret-down ml5" />
				</button>
			) : (
				<span onClick={toggle}>
					<i className="fa fa-bars" />
				</span>
			)}
			<ul style={{ display: open ? '' : 'none' }} onClick={doClose}>
				{children}
			</ul>
		</div>
	);
};

export default FloatingMenu;
